import { render, staticRenderFns } from "./agreement2.vue?vue&type=template&id=ef619a80&scoped=true"
import script from "./agreement2.vue?vue&type=script&lang=js"
export * from "./agreement2.vue?vue&type=script&lang=js"
import style0 from "./agreement2.vue?vue&type=style&index=0&id=ef619a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef619a80",
  null
  
)

export default component.exports